import { v4 as uuidv4 } from "uuid";
import { db, timeStamp, arrayUnion } from "../firebase/firebase.config.js";
import selectedMonth from "./selectedMonth.js";
import _ from "lodash";

const handleExpenses = (data, uid, ExpenseStore, BankStore) => {
	return new Promise((resolve, reject) => {
		const {
			expenseTitle,
			expenseCatagory,
			expenseAmount,
			selectedBank,
			expenseDate,
		} = data;
		let currentTimeStamp;
		let selectedYear;
		const uuid = uuidv4();
		const uidBanks = db.collection(uid).doc("banks");
		const uidExpenses = db.collection(uid).doc("expenses");
		const expensesHistory = uidExpenses.collection("history");
		let latestTotalAmount;
		let lastTotalAmount;

		let expenseDateVal = new Date(expenseDate);
		selectedYear = expenseDateVal.getFullYear();
		let expenseDateNum = expenseDateVal.getDate();
		let selectedMnth = selectedMonth(expenseDateVal.getMonth());

		const deductFunds = () => {
			uidBanks.get().then((querySnapShot) => {
				if (querySnapShot.data()) {
					let monthlyBankData = querySnapShot.data()["monthlyBank"];
					let reserveBankData = querySnapShot.data()["reserveBank"];

					if (monthlyBankData) {
						let monthlyBankTotalAmount = monthlyBankData.totalAmount;
						let reserveBankTotalAmount = reserveBankData.totalAmount;
						let deductedAmount;

						if (monthlyBankTotalAmount < expenseAmount) {
							if (monthlyBankTotalAmount > 0) {
								let remainingAmount = expenseAmount - monthlyBankTotalAmount;
								let deductableAmount = expenseAmount - remainingAmount;

								BankStore.update((data) => {
									const currentAmount = data["monthlyBank"].totalAmount;

									deductedAmount = currentAmount - deductableAmount;

									data["monthlyBank"].totalAmount = deductedAmount;

									return data;
								});

								uidBanks.update({
									[`monthlyBank.totalAmount`]: deductedAmount,
								});

								BankStore.update((data) => {
									const currentAmount = data["reserveBank"].totalAmount;

									deductedAmount = currentAmount - remainingAmount;

									data["reserveBank"].totalAmount = deductedAmount;

									return data;
								});

								uidBanks.update({
									[`reserveBank.totalAmount`]: deductedAmount,
								});
							} else {
								BankStore.update((data) => {
									const currentAmount = data["reserveBank"].totalAmount;

									deductedAmount = currentAmount - expenseAmount;

									data["reserveBank"].totalAmount = deductedAmount;

									return data;
								});

								uidBanks.update({
									[`reserveBank.totalAmount`]: deductedAmount,
								});
							}
						} else {
							BankStore.update((data) => {
								const currentAmount = data["monthlyBank"].totalAmount;

								deductedAmount = currentAmount - expenseAmount;

								data["monthlyBank"].totalAmount = deductedAmount;

								return data;
							});

							uidBanks.update({
								[`monthlyBank.totalAmount`]: deductedAmount,
							});
						}
					} else {
						console.log("selected bank doesnt exists");
					}
				} else {
					console.log("banks doesnt exists");
				}
			});
		};

		// App Store / App State.

		const updateSelectedMonthsHistoryInAppStore = (
			currentTimeStamp,
			totalMonthAmount,
			totalYearAmount
		) => {
			ExpenseStore.update((data) => {
				const SYear = data.data.history[selectedYear];
				const SMonth = data.data.history[selectedYear][selectedMnth];

				SYear.total = totalYearAmount;
				SYear.monthsList[selectedMnth] = totalMonthAmount;

				if (!_.includes(SMonth.daysList, expenseDateNum)) {
					SMonth.daysList.push(expenseDateNum);
				}

				if (_.has(SMonth, expenseDateNum)) {
					SMonth[expenseDateNum].push({
						recordId: uuid,
						expenseTitle: expenseTitle,
						expenseCatagory: expenseCatagory,
						expenseAmount: expenseAmount,
						selectedBank: selectedBank,
						expenseDate: expenseDateVal,
						timeStamp: currentTimeStamp,
					});
				} else {
					SMonth[expenseDateNum] = [
						{
							recordId: uuid,
							expenseTitle: expenseTitle,
							expenseCatagory: expenseCatagory,
							expenseAmount: expenseAmount,
							selectedBank: selectedBank,
							expenseDate: expenseDateVal,
							timeStamp: currentTimeStamp,
						},
					];
				}

				return data;
			});
		};

		const createNewMonthsHistoryInAppStore = (
			currentTimeStamp,
			totalYearAmount
		) => {
			ExpenseStore.update((data) => {
				const SYear = data.data.history[selectedYear];

				SYear.total = totalYearAmount;
				SYear.monthsList[selectedMnth] = expenseAmount;

				SYear[selectedMnth] = {
					daysList: [expenseDateNum],
					[expenseDateNum]: [
						{
							recordId: uuid,
							expenseTitle: expenseTitle,
							expenseCatagory: expenseCatagory,
							expenseAmount: expenseAmount,
							selectedBank: selectedBank,
							expenseDate: expenseDateVal,
							timeStamp: currentTimeStamp,
						},
					],
				};

				return data;
			});
		};

		const createNewYearsHistoryInAppStore = (currentTimeStamp) => {
			ExpenseStore.update((data) => {
				data.data.history = {
					yearsList: [`${selectedYear}`],
					[selectedYear]: {
						total: expenseAmount,
						monthsList: {
							[selectedMnth]: expenseAmount,
						},
						[selectedMnth]: {
							daysList: [expenseDateNum],
							[expenseDateNum]: [
								{
									recordId: uuid,
									expenseTitle: expenseTitle,
									expenseCatagory: expenseCatagory,
									expenseAmount: expenseAmount,
									selectedBank: selectedBank,
									expenseDate: expenseDateVal,
									timeStamp: currentTimeStamp,
								},
							],
						},
					},
				};

				return data;
			});
		};

		const updateSelectedExpenseCatagoryInAppStore = (latestTotalAmount) => {
			ExpenseStore.update((data) => {
				//console.log(data[expenseCatagory]);
				data.data[`${expenseCatagory}`] = {
					recordId: uuid,
					expenseTitle: expenseTitle,
					expenseAmount: expenseAmount,
					selectedBank: selectedBank,
					expenseDate: expenseDateVal,
					expenseTimeStamp: timeStamp,
					totalAmount: latestTotalAmount,
				};
				return data;
			});
		};

		const updateWithNewExpenseCatagoryInAppStore = () => {
			ExpenseStore.update((data) => {
				data.data[`${expenseCatagory}`] = {
					recordId: uuid,
					expenseTitle: expenseTitle,
					expenseAmount: expenseAmount,
					selectedBank: selectedBank,
					expenseDate: expenseDateVal,
					expenseTimeStamp: timeStamp,
					totalAmount: expenseAmount,
				};
				return data;
			});
		};

		const createNewExpenseCatagoryInAppStore = () => {
			ExpenseStore.set({
				data: {
					[`${expenseCatagory}`]: {
						recordId: uuid,
						expenseTitle: expenseTitle,
						expenseAmount: expenseAmount,
						selectedBank: selectedBank,
						expenseDate: expenseDateVal,
						expenseTimeStamp: timeStamp,
						totalAmount: expenseAmount,
					},
				},
			});
		};

		// Remote db.

		const updateSelectedMonthsHistoryInRemoteDb = (
			currentTimeStamp,
			totalExpenseAmount,
			totalYearAmount
		) => {
			expensesHistory
				.doc(`${selectedYear}`)
				.update({
					total: totalYearAmount,
					[`monthsList.${selectedMnth}`]: totalExpenseAmount,
					[`${selectedMnth}.daysList`]: arrayUnion(expenseDateNum),
					[`${selectedMnth}.${expenseDateNum}`]: arrayUnion({
						recordId: uuid,
						expenseTitle: expenseTitle,
						expenseCatagory: expenseCatagory,
						expenseAmount: expenseAmount,
						selectedBank: selectedBank,
						expenseDate: expenseDateVal,
						timeStamp: currentTimeStamp,
					}),
				})
				.then(() => {
					resolve({
						dataSaved: true,
					});
				});
		};

		const createNewMonthsHistoryInRemoteDb = (
			currentTimeStamp,
			totalYearAmount
		) => {
			expensesHistory
				.doc(`${selectedYear}`)
				.update({
					total: totalYearAmount,
					[`monthsList.${selectedMnth}`]: expenseAmount,
					[`${selectedMnth}`]: {
						daysList: [expenseDateNum],
						[`${expenseDateNum}`]: [
							{
								recordId: uuid,
								expenseTitle: expenseTitle,
								expenseCatagory: expenseCatagory,
								expenseAmount: expenseAmount,
								selectedBank: selectedBank,
								expenseDate: expenseDateVal,
								timeStamp: currentTimeStamp,
							},
						],
					},
				})
				.then(() => {
					resolve({
						dataSaved: true,
					});
				});
		};

		const createNewYearsHistoryInRemoteDb = (currentTimeStamp) => {
			createNewYearsHistoryInAppStore(currentTimeStamp);

			expensesHistory
				.doc(`${selectedYear}`)
				.set({
					total: expenseAmount,
					monthsList: {
						[`${selectedMnth}`]: expenseAmount,
					},
					[`${selectedMnth}`]: {
						daysList: [expenseDateNum],
						[`${expenseDateNum}`]: [
							{
								recordId: uuid,
								expenseTitle: expenseTitle,
								expenseCatagory: expenseCatagory,
								expenseAmount: expenseAmount,
								selectedBank: selectedBank,
								expenseDate: expenseDateVal,
								timeStamp: currentTimeStamp,
							},
						],
					},
				})
				.then(() => {
					resolve({
						dataSaved: true,
					});
				});
		};

		const createOrUpdateHistoryInRemoteDb = () => {
			expensesHistory
				.doc(`${selectedYear}`)
				.get()
				.then((shot) => {
					if (shot.exists) {
						if (shot.data()[selectedMnth]) {
							const totalYearAmount = shot.data().total + expenseAmount;
							const totalMonthAmount =
								shot.data().monthsList[selectedMnth] + expenseAmount;

							currentTimeStamp = new Date();

							updateSelectedMonthsHistoryInAppStore(
								currentTimeStamp,
								totalMonthAmount,
								totalYearAmount
							);

							updateSelectedMonthsHistoryInRemoteDb(
								currentTimeStamp,
								totalMonthAmount,
								totalYearAmount
							); // Update selected month's history record.
							// console.log("Update selected month's history record.");
						} else {
							// console.log(`Selected Month doesn't exists.`);
							const totalYearAmount = shot.data().total + expenseAmount;

							createNewMonthsHistoryInAppStore(
								currentTimeStamp,
								totalYearAmount
							);

							currentTimeStamp = new Date();
							createNewMonthsHistoryInRemoteDb(
								currentTimeStamp,
								totalYearAmount
							);
							// console.log(`Create new month's history record.`);
						}
					} else {
						// console.log('year doesnt exists');

						currentTimeStamp = new Date();
						createNewYearsHistoryInRemoteDb(currentTimeStamp); // Create new year's history record.
						// console.log(`Create new year's history record.`);
					}
				});
		};

		const updateSelectedExpenseCatagoryInRemoteDb = (latestTotalAmount) => {
			uidExpenses
				.update({
					[`${expenseCatagory}.recordId`]: uuid,
					[`${expenseCatagory}.lastExpenseTitle`]: expenseTitle,
					[`${expenseCatagory}.lastExpenseAmount`]: expenseAmount,
					[`${expenseCatagory}.lastSelectedBank`]: selectedBank,
					[`${expenseCatagory}.lastExpenseDate`]: expenseDateVal,
					[`${expenseCatagory}.lastExpenseTimeStamp`]: timeStamp,
					[`${expenseCatagory}.totalAmount`]: latestTotalAmount,
				})
				.then(() => {
					createOrUpdateHistoryInRemoteDb();
				});
		};

		const updateWithNewExpenseCatagoryInRemoteDb = () => {
			uidExpenses
				.update({
					[`${expenseCatagory}`]: {
						recordId: uuid,
						lastExpenseTitle: expenseTitle,
						lastExpenseAmount: expenseAmount,
						lastSelectedBank: selectedBank,
						lastExpenseDate: expenseDateVal,
						lastExpenseTimeStamp: timeStamp,
						totalAmount: expenseAmount,
					},
				})
				.then(() => {
					createOrUpdateHistoryInRemoteDb();
				});
		};

		const createNewExpenseCatagoryDocInRemoteDb = () => {
			uidExpenses
				.set({
					[`${expenseCatagory}`]: {
						recordId: uuid,
						lastExpenseTitle: expenseTitle,
						lastExpenseAmount: expenseAmount,
						lastSelectedBank: selectedBank,
						lastExpenseDate: expenseDateVal,
						lastExpenseTimeStamp: timeStamp,
						totalAmount: expenseAmount,
					},
				})
				.then(() => {
					currentTimeStamp = new Date();
					createNewYearsHistoryInRemoteDb(currentTimeStamp); // Create new year's history record.
					// console.log(`Create new year's history record.`);
				});
		};

		// Get uidBanks
		uidExpenses.get().then((querySnapShot) => {
			// Check if data exists
			if (querySnapShot.exists) {
				// console.log('data exists');

				if (querySnapShot.data()[`${expenseCatagory}`]) {
					// console.log('selected expense catagory exists');

					lastTotalAmount = querySnapShot.data()[`${expenseCatagory}`]
						.totalAmount;
					latestTotalAmount = lastTotalAmount + expenseAmount;

					// Update data for totalAmount in local state.
					updateSelectedExpenseCatagoryInAppStore(latestTotalAmount);

					updateSelectedExpenseCatagoryInRemoteDb(latestTotalAmount); // Update selected expense catagory's latest info record.
					// console.log(`Update selected expense catagory's latest info record`);

					deductFunds();
				} else {
					// console.log('selected expense catagory doesnt exists');

					// Update local state with new catagory record.
					updateWithNewExpenseCatagoryInAppStore();

					updateWithNewExpenseCatagoryInRemoteDb(); // Create new expense catagory's latest info record.
					// console.log(`Create new expense catagory's latest info record`);

					deductFunds();
				}
			} else {
				// Initialize data records. This happens at the very begining of the app history.
				// console.log('data doesnt exists');

				createNewExpenseCatagoryInAppStore();

				createNewExpenseCatagoryDocInRemoteDb();

				deductFunds();
			}
		});
	});
};

const validateData = (data) => {
	let {
		expenseTitle,
		expenseCatagory,
		expenseAmount,
		selectedBank,
		expenseDate,
	} = data;

	return new Promise((resolve, reject) => {
		if (expenseTitle == "") {
			reject({
				msg: "expense title is required",
				field: "titleEmpty",
			});
		}

		if (expenseCatagory == undefined) {
			reject({
				msg: "expense catagory is required",
				field: "catagoryEmpty",
			});
		}

		if (expenseAmount == undefined) {
			reject({
				msg: "expense amount is required",
				field: "amountEmpty",
			});
		}

		if (selectedBank == undefined) {
			reject({
				msg: "selectedBank is required",
				field: "bankEmpty",
			});
		}

		if (expenseDate == undefined) {
			reject({
				msg: "expense date is required",
				field: "dateEmpty",
			});
		} else {
			resolve({
				validation: true,
			});
		}
	});
};

export { handleExpenses, validateData };
